import React from "react";

export default function Widget() {
  return (
    <>
      <div
        class="wl-widget"
        data="k_skin=188418&amp;url_page=xCTXsimWI7U61jCJhyZ3wd3C4eo%3Ahttps%3A%2F%2Fthestrengthstore.com.au%2F"
      ></div>
      <a
        href="https://www.wellnessliving.com/fitness/"
        rel="nofollow"
        style={{ float: "right" }}
      >
        <img
          src="https://s3.amazonaws.com/wl-static/file/J.png"
          alt="Fitness management software"
          height="39"
          width="135"
        />
      </a>
      <br clear="both" />
    </>
  );
}
